import 'babel-polyfill';
import Vue from 'vue';
import App from './app';
import VueTranslate from 'vue-translate-plugin';
import Vuerify from 'vuerify';

Vue.use(VueTranslate);
Vue.use(Vuerify);

const vm = new Vue({ // eslint-disable-line
  el: '#app',
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/pages/index/index.js